import { Button } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../App.css";
import { getLicenseKey, getValid } from "../../Utils/actions";
import DOMPurify from "dompurify";
import CopyToClipboardButton from "./CopyToClipboardButton";
import { Card } from "react-bootstrap";
import { Box, Input, Modal, Typography } from "@mui/material";
import { buttonStyle, cancelBtnStyle, confirmBtnStyle } from "../../Style/ManualStyle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import background from "../../Assets/Images/bgLicense.jpg";
import { useLocation } from "react-router-dom";
import "./LicenseManage.css";

const LicenseManage = ({ validKey }) => {
  const dispatch = useDispatch();
  const { keyGenerate, isValidKey } = useSelector((state) => state.data);
  const [open, setOpen] = useState(true);
  const location = useLocation();
  const handleClose = () => setOpen(false);
  const [keepMount, setKeepMount] = useState(true);
  // const  = "MDI0MjRDMTExQzIyLWRvY2tlcjAjMDI0MjU2NTI4NTUwLWJyLWZlZDIyY2YwNjVhMSNBNjQ3ODI0Q0VCQ0ItdmV0aGJjOTE1YWYjRTBENTVFNzQzRjNCLWVucDFzMCNFMkQyNDNBRUY5Q0EtdmV0aDRjZjNjNTcj"
  const [upload, setUpload] = useState(null);

  const generateKey = (e) => {
    e.preventDefault();
    dispatch(getLicenseKey());
  };

  const uploadFile = async (e) => {
    e.preventDefault();
    const fileUpload = new FormData();
    fileUpload.append("file", upload);
    dispatch(getValid(fileUpload));
  };

  const onFileChange = async (event) => {
    if (event.target.files.length > 0) {
      setUpload(event.target.files[0]);
      const fileUpload = new FormData();
      fileUpload.append("file", event.target.files[0]);
      await dispatch(getValid(fileUpload));
    }
  };

  const style = {
    width: 400,
    backgroundColor: "rgb(19 76 114)",
    color: "#fff",
    border: "2px solid rgba(0, 0, 0, 0.3)", // Transparent border
    borderRadius: "12px", // Border-radius
    p: 2,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  const handleConfirm = () => {
    setOpen(!open);
    setKeepMount(!keepMount);
    if (location.pathname === "/validForm") {
      validKey(false);
    }
  };

  const handleCancel = () => {
    setOpen(!open);
    setKeepMount(!keepMount);
    if (location.pathname === "/validForm") {
      validKey(true);
    }
  };

  return (
    <Fragment>
      {/* Section 1: Generate License Key */}
      {/* <div className='w-100 position-relative' style={{ height: '100vh'}}> */}
      <Card
        className="shadow-none licensePage border-0"
        // style={{ height: "calc(100vh - 7vh)" }}
        style={{ height: "calc(100vh - 7vh)" }}
      >
        <Card.Body
          style={{
            margin: 0,
            padding: 0,
            overflow: "auto",
            backgroundColor: "#333",
          }}
        >
          {!isValidKey || location.pathname === "/manage" ? (
            <div
              className="col-md-12 card-certificate-content d-flex flex-column align-items-center"
              style={{ marginTop: "32px" }}
            >
              <div className="text-center mb-3">
                <strong style={{ color: "#c7c7c7", fontSize: "1.25rem" }}>
                  Get Your Personalized License Key
                </strong>
              </div>

              <div
                className="file-upload-content"
                style={{
                //   border: "1px solid black",
                  borderRadius: "10px",
                  padding: "15px",
                  backgroundColor: "#242424",
                  color: "#c7c7c7",
                  width: "550px",
                  maxWidth: "900px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                }}
              >
                <div
                  className={`overflow-auto mb-3 ${
                    keyGenerate !== "" ? "d-flex" : "d-none"
                  }`}
                  style={{ gap: "10px" }}
                >
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(keyGenerate),
                    }}
                    style={{
                      fontSize: "12px",
                      flex: 1,
                      wordBreak: "break-all",
                    }}
                  />
                  <CopyToClipboardButton keyString={keyGenerate} />
                </div>

                <div className="d-flex justify-content-center align-items-center mt-3">
                  {keyGenerate !== null && keyGenerate !== "" ? (
                    <>
                      <Input
                        id="fileInput"
                        type="file"
                        style={{ display: "none" }}
                        onChange={onFileChange}
                      />
                      <label htmlFor="fileInput">
                        <Button
                          style={{
                            ...buttonStyle,
                            // color: "rgb(38 85 116)",
                            border: "none",
                            // backgroundColor: "#fff",
                          }}
                          component="span"
                          startIcon={<CloudUploadIcon />}
                        >
                          Upload File
                        </Button>
                      </label>
                      <span style={{ marginLeft: "10px", fontSize: "12px" }}>
                        {upload && `Selected file: ${upload?.name}`}
                      </span>
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                         ...buttonStyle,
                        // backgroundColor: "#fff",
                        // color: "rgb(38 85 116)",
                        border: "none",
                        boxShadow: "none",
                      }}
                      onClick={generateKey}
                    >
                      Generate License Key
                    </Button>
                  )}
                </div>
              </div>

              <div
                className="licence-description mt-4"
                style={{
                  padding: "20px",
                //   borderLeft: "1px solid black",
                  fontSize: "12px",
                  backgroundColor: "#242424",
                  color: "#c7c7c7",
                  maxWidth: "900px",
                  overflow: "auto",
                  borderRadius: "10px",
                  marginBottom: "20px",
                }}
              >
                <h4
                  className="licence-heading"
                  style={{ paddingBottom: "20px" }}
                >
                  Request Your Personalized License Key
                </h4>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  <li>
                    <p className="jubilant-subtitle">
                      On the page, locate the <b>"Generate License Key"</b>{" "}
                      button and click on it. This button will generate a unique
                      license key.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Once the license key is generated, select and copy the
                      generated text.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Open your email client or webmail service and compose a
                      new email.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      In the recipient field, enter the email address{" "}
                      <b>support@sigmastream.com</b>
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      In the subject field, provide a descriptive subject line,
                      such as "License Key for [Veras]."
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      In the body of the email, type a message to the recipient.
                      Include instructions for using the license key and any
                      additional information they may need.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Include the username in the email body. You can either
                      instruct the user to provide their username in a specific
                      format or retrieve it from a form they filled out on the
                      website.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Paste the license key that you copied earlier into the
                      email body.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Double-check the email for accuracy, ensuring that the
                      license key and username are correctly included.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Once you are satisfied with the email content, click the
                      "Send" button to send the email with the license key and
                      username to the recipient.
                    </p>
                  </li>
                  <li>
                    <p className="jubilant-subtitle">
                      Inform the user that they should check their email for the
                      license key and provide any further instructions if
                      necessary.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundImage: `url(${background})`,
                backgroundSize: "100vw 86vh",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                keepMounted={keepMount}
                hideBackdrop={keepMount}
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    License Validation is completed.
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    If you want to create a user then Click on Yes otherwise No
                  </Typography>
                  <div className="d-flex justify-content-between mt-4">
                    <Button
                      title="Yes"
                      variant="contained"
                      color="primary"
                      style={confirmBtnStyle}
                      onClick={handleConfirm}
                    >
                      Yes
                    </Button>
                    <Button
                      title="No"
                      variant="contained"
                      color="primary"
                      style={cancelBtnStyle}
                      onClick={handleCancel}
                    >
                      No
                    </Button>
                  </div>
                </Box>
              </Modal>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* </div> */}
    </Fragment>
  );
};

export default LicenseManage;
